import { render, staticRenderFns } from "./PdfLayout.vue?vue&type=template&id=764f3e96&scoped=true&"
import script from "./PdfLayout.vue?vue&type=script&lang=js&"
export * from "./PdfLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764f3e96",
  null
  
)

export default component.exports